import React from 'react';
import { useTheme } from '../../../context/ThemeContext';
import CustomCard from '../../Scanners/components/CustomCard';

/**
 * Skeleton loader for Heat Map Section
 */
const HeatMapSkeleton = () => {
  const { theme } = useTheme();

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-3">
        <div className="h-4 w-24 bg-n200 rounded animate-pulse"></div>
        <div className="h-3 w-32 bg-n200 rounded animate-pulse"></div>
      </div>

      <CustomCard>
        <div className="w-full space-y-6">
          {[...Array(2)].map((_, index) => (
            <div key={index}>
              <div className="h-3 w-32 bg-n200 rounded animate-pulse mb-2"></div>
              <div className="h-[200px] bg-n200 rounded animate-pulse"></div>
            </div>
          ))}
        </div>
      </CustomCard>
    </div>
  );
};

export default HeatMapSkeleton;
